import React from "react";
import { useNavigate } from "react-router";
import { ArrowForward } from "@material-ui/icons";
import { isVendorComingSoon } from "./vendorData";

const VendorSelectionCard = ({ vendor }) => {
  const navigate = useNavigate();
  const comingSoon = isVendorComingSoon(vendor);

  const handleSelect = () => {
    navigate(`/dashboard/rate-analysis/${vendor.slug}`);
  };

  return (
    <div
      className={`rate-analysis-vendor-card ${
        comingSoon ? "rate-analysis-vendor-card-soon" : ""
      }`}
      onClick={handleSelect}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleSelect();
        }
      }}
      role="button"
      tabIndex={0}
    >
      {comingSoon && (
        <span className="rate-analysis-vendor-card-soon-badge">Coming Soon</span>
      )}

      <div className="rate-analysis-vendor-card-top">
        <div className="rate-analysis-vendor-card-avatar">
          <img src={vendor.circleIcon} alt="" />
        </div>
      </div>

      <div className="rate-analysis-vendor-card-content">
        <div className="rate-analysis-vendor-card-brand">
          <img
            src={vendor.mainImage}
            alt={vendor.value}
            className="rate-analysis-vendor-card-logo"
          />
        </div>

        <h3 className="rate-analysis-vendor-card-title">{vendor.value}</h3>
        <p className="rate-analysis-vendor-card-desc">{vendor.description}</p>

        <button
          type="button"
          className={`rate-analysis-vendor-card-btn ${
            comingSoon ? "rate-analysis-vendor-card-btn-soon" : ""
          }`}
        >
          {comingSoon ? "View Details" : "Analyze Rates"}
          <ArrowForward className="rate-analysis-vendor-card-btn-icon" />
        </button>
      </div>
    </div>
  );
};

export default VendorSelectionCard;
